module.exports = __webpack_public_path__ + "public/img/ico-tabbar-active-system.c3296633.svg";